import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentService } from '../../../../../core/services/document.service';
import { PlatformService } from '../../../../../core/services/platform.service';
import { SEOService } from '../../../../../core/services/seo.service';
import { LandingPageDataService } from '../../services/landing-post-data.service';
import { LandingPostService } from '../../services/landing-post.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LandingPageDataService],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LandingPageComponent {
  constructor(
    private activatedRouter: ActivatedRoute,
    public landingPageDataService: LandingPageDataService,
    private landingPostService: LandingPostService,
    private seoService: SEOService,
    private documentService: DocumentService,
    public pt: PlatformService,
    private router: Router,
  ) { }

  async ngOnInit() {
    let pd = this.activatedRouter.snapshot.data['postDetails'] as any;
    this.landingPageDataService.landingId.set(pd.path);
    this.landingPageDataService.isQrCode.set(pd.isQrCode);
    this.landingPageDataService.details.set(pd.details);
    this.landingPageDataService.isLoaded.set(true);
    this.setPageInfo();
    this.saveVisitor();
  }

  setPageInfo() {
    const parser = new DOMParser();
    const doc = parser.parseFromString(
      this.landingPageDataService.details().pageInfo.description || '',
      'text/html',
    );
    this.seoService.setPageSEO(
      {
        title: this.landingPageDataService.details().pageInfo?.title || '',
        description: doc.body.textContent?.substring(0, 160) || '',
        image:
          this.landingPageDataService.details().pageInfo.image ||
          this.landingPageDataService.details().user?.picturePath,
      } as any
    );
  }

  async saveVisitor() {
    if (this.pt.isServer) {
      return;
    }
    // await this.documentService.onFirstScroll();
    this.landingPostService.saveVisitor(
      this.landingPageDataService.details()._id,
      this.landingPageDataService.isQrCode(),
      this.landingPageDataService.details().user?._id,
    );
  }
}
